export const FETCH_COURSE_QUIZZES = 'FETCH_COURSE_QUIZZES'
export const FETCH_COURSE_QUIZZES_SUCCESS = 'FETCH_COURSE_QUIZZES_SUCCESS'
export const FETCH_COURSE_QUIZZES_FAILURE = 'FETCH_COURSE_QUIZZES_FAILURE'
export const FETCH_COURSE_QUIZZES_CANCEL = 'FETCH_COURSE_QUIZZES_CANCEL'
